import { render } from "./ColumnsSelector.vue?vue&type=template&id=53f0faa2"
import script from "./ColumnsSelector.vue?vue&type=script&lang=js"
export * from "./ColumnsSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__